import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "columns", "stickyHeader", "stickySidebar"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var PricingTableContext = /*#__PURE__*/createContext(null);
export var PricingTableContextProvider = function PricingTableContextProvider(_ref) {
  var children = _ref.children,
      columns = _ref.columns,
      stickyHeader = _ref.stickyHeader,
      stickySidebar = _ref.stickySidebar,
      rest = _objectWithoutProperties(_ref, _excluded);

  var value = useMemo(function () {
    return {
      columns: columns,
      stickyHeader: stickyHeader,
      stickySidebar: stickySidebar
    };
  }, [columns, stickyHeader, stickySidebar]);
  return _jsx(PricingTableContext.Provider, _objectSpread(_objectSpread({
    value: value
  }, rest), {}, {
    children: children
  }));
};
export var usePricingTable = function usePricingTable() {
  var context = useContext(PricingTableContext);

  if (!context) {
    throw new Error("Pricing table context isn't available. Please set it via TablePricing component.");
  }

  return context;
};